import { MutationTree } from "vuex";
import {Owner} from "@/store/modules/hcs/Model";
import {OwnerState} from "@/store/modules/hcs/owner/model";

const mutations: MutationTree<OwnerState> = {
  setOwner(state, {ownerId, owner}: {ownerId: string; owner: Owner | Promise<Owner>}) {
    state.owners.set(ownerId, owner);
  },

}

export default mutations;
